/** Icônes Lucide disponibles dans Just One Page (nom = clé AppIcon). */
export const ICON_CATALOG = [
  {
    id: 'general',
    label: 'Général',
    icons: [
      'Star',
      'Heart',
      'Sparkles',
      'Zap',
      'Flame',
      'Award',
      'Trophy',
      'Crown',
      'Gem',
      'Target',
      'Flag',
      'Bookmark',
      'Tag',
      'Gift',
      'PartyPopper',
    ],
  },
  {
    id: 'communication',
    label: 'Communication',
    icons: [
      'Mail',
      'Phone',
      'MessageCircle',
      'MessagesSquare',
      'Send',
      'Bell',
      'BellRing',
      'Megaphone',
      'AtSign',
      'Share2',
      'Link',
      'ExternalLink',
    ],
  },
  {
    id: 'business',
    label: 'Business',
    icons: [
      'Building2',
      'Briefcase',
      'Users',
      'User',
      'UserPlus',
      'Handshake',
      'TrendingUp',
      'BarChart3',
      'PieChart',
      'CreditCard',
      'Wallet',
      'Receipt',
      'ShoppingCart',
      'Package',
      'Truck',
    ],
  },
  {
    id: 'navigation',
    label: 'Navigation',
    icons: [
      'Home',
      'MapPin',
      'Map',
      'Compass',
      'Navigation',
      'Globe',
      'ArrowRight',
      'ArrowLeft',
      'ChevronRight',
      'ChevronDown',
      'Menu',
      'LayoutGrid',
      'Layers',
    ],
  },
  {
    id: 'media',
    label: 'Médias',
    icons: [
      'Image',
      'Camera',
      'Video',
      'Play',
      'Pause',
      'Music',
      'Mic',
      'Volume2',
      'Film',
      'Youtube',
    ],
  },
  {
    id: 'tech',
    label: 'Tech',
    icons: [
      'Smartphone',
      'Laptop',
      'Monitor',
      'Wifi',
      'Cloud',
      'Database',
      'Server',
      'Code',
      'Terminal',
      'Cpu',
      'QrCode',
      'Scan',
    ],
  },
  {
    id: 'status',
    label: 'Statut',
    icons: [
      'Check',
      'CheckCircle',
      'X',
      'XCircle',
      'AlertCircle',
      'AlertTriangle',
      'Info',
      'HelpCircle',
      'Shield',
      'ShieldCheck',
      'Lock',
      'Unlock',
      'Eye',
      'EyeOff',
    ],
  },
  {
    id: 'time',
    label: 'Temps',
    icons: [
      'Clock',
      'Calendar',
      'CalendarDays',
      'Timer',
      'Hourglass',
      'History',
    ],
  },
  {
    id: 'files',
    label: 'Documents',
    icons: [
      'FileText',
      'File',
      'Files',
      'Folder',
      'Download',
      'Upload',
      'Paperclip',
      'Clipboard',
      'BookOpen',
      'Newspaper',
    ],
  },
  {
    id: 'social',
    label: 'Social',
    icons: [
      'ThumbsUp',
      'ThumbsDown',
      'Smile',
      'Laugh',
      'Coffee',
      'Utensils',
      'Plane',
      'Car',
      'Bike',
      'TreePine',
      'Sun',
      'Moon',
      'CloudRain',
    ],
  },
];

export const ALL_ICON_NAMES = ICON_CATALOG.flatMap((group) => group.icons);

export function isValidIconName(name) {
  return ALL_ICON_NAMES.includes(name);
}

export function normalizeIconName(name, fallback = 'Star') {
  return isValidIconName(name) ? name : fallback;
}
